// Login.jsx - Focused only on authentication
import { useState, useEffect } from "react";
import { postRequest } from "../apiService";

export function Login({ onLoginSuccess }) {
  const [inputs, setInputs] = useState({});
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    document.title = "Login";
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!inputs.email || !inputs.password) {
      setErrorMsg("Please enter both email and password");
      return;
    }

    setIsLoading(true);
    setErrorMsg("");

    try {
      const loginData = { 
        email: inputs.email, 
        password: inputs.password 
      };

      const result = await postRequest("user/login", loginData);
      
      if (result.success) {
          onLoginSuccess(result.data.data, true);
      } else {
        setErrorMsg(result.error || "Login failed");
      }
    } catch (error) {
      setErrorMsg("Network error. Please try again.");
      console.error("Login error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  function togglePasswordVisibility() {
    const pVisibility = document.getElementById("login-password");
    const pIcon = document.getElementById("password-visibility-state");
    
    if (pVisibility.type === "password") {
      pVisibility.type = "text";
      pIcon.innerHTML = "visibility";
      pIcon.classList.add("showPassword-txt-btn");
    } else {
      pVisibility.type = "password";
      pIcon.innerHTML = "visibility_off";
      pIcon.classList.remove("showPassword-txt-btn");
    }
  }

  return (
    <div id="background-blue">
      <div id="Login-box">
        <svg
          width="214"
          height="35"
          viewBox="0 0 214 35"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMinYMin meet"
        >
          <path d="M32.6264 8.6754H27.902V0H15.1099V8.6754H10.3855V5.27919H0V27.1697H17.7968V22.1301C17.7968 20.0828 19.4651 18.4121 21.5094 18.4121C23.5536 18.4121 25.2219 20.0828 25.2219 22.1301V27.1697H43.0187V5.27919H32.6264V8.6754Z" />
          <path d="M213.589 24.2177V26.4799C212.358 26.8458 211.393 26.9456 210.661 26.9456C207.6 26.9456 206.037 25.4818 206.037 22.3879V12.0416H203.575V9.94578H206.037V5.6875H208.765V9.94578H213.156V12.0416H208.731V22.2549C208.731 24.018 209.63 24.6169 211.16 24.6169C211.792 24.6169 212.524 24.5503 213.589 24.2177Z" />
          <path d="M188.615 9.94414V13.0048C189.413 10.9422 191.509 9.54492 194.071 9.54492C197.83 9.54492 200.059 11.9069 200.059 15.8991V26.6778H197.298V16.4979C197.298 13.404 195.934 11.8071 193.306 11.8071C190.744 11.8071 188.715 13.4373 188.715 17.4627V26.6778H185.954V9.94414H188.615Z" />
          <path d="M181.175 21.7542C180.41 25.3138 177.515 27.077 174.255 27.077C169.531 27.077 166.204 23.7835 166.204 18.3941C166.204 12.9382 169.631 9.54492 174.089 9.54492C179.046 9.54492 181.275 13.5038 181.275 17.7953V18.8932H168.899C169.032 22.7522 171.061 24.8814 174.255 24.8814C176.517 24.8814 177.881 23.7835 178.58 21.7542H181.175ZM174.089 11.7739C171.461 11.7739 169.465 13.4705 168.999 16.8971H178.58C178.513 14.0028 177.083 11.7739 174.089 11.7739Z" />
          <path d="M158.711 25.6133V23.1514C157.946 24.7816 156.083 26.3784 153.155 26.3784C148.864 26.3784 145.736 23.1514 145.736 17.9284C145.736 12.905 148.864 9.54492 153.155 9.54492C156.083 9.54492 158.012 11.2748 158.811 12.8717V9.94414H161.505V25.4137C161.505 30.7365 158.045 32.9987 153.588 32.9987C149.562 32.9987 146.834 31.3686 146.169 28.1083H148.963C149.529 30.2042 151.292 30.8696 153.554 30.8696C156.848 30.8696 158.711 29.1064 158.711 25.6133ZM158.91 18.3276V17.5292C158.91 14.0693 156.748 11.7073 153.654 11.7073C150.394 11.7073 148.464 14.2024 148.464 17.9284C148.464 21.6211 150.394 24.1827 153.654 24.1827C156.748 24.1827 158.91 21.7875 158.91 18.3276Z" />
          <path d="M140.481 26.679L137.853 20.0587H126.475L123.847 26.679H120.986L130.601 2.92578H133.828L143.475 26.679H140.481ZM132.131 5.78681L127.407 17.6967H136.921L132.231 5.78681H132.131Z" />
          <path d="M117.468 26.6784H114.707V2.19336H117.468V26.6784Z" />
          <path d="M109.929 21.7542C109.163 25.3138 106.269 27.077 103.009 27.077C98.2848 27.077 94.958 23.7835 94.958 18.3941C94.958 12.9382 98.3846 9.54492 102.842 9.54492C107.799 9.54492 110.028 13.5038 110.028 17.7953V18.8932H97.6527C97.7858 22.7522 99.8151 24.8814 103.009 24.8814C105.271 24.8814 106.635 23.7835 107.334 21.7542H109.929ZM102.842 11.7739C100.214 11.7739 98.2183 13.4705 97.7525 16.8971H107.334C107.267 14.0028 105.837 11.7739 102.842 11.7739Z" />
          <path d="M91.8881 24.2177V26.4799C90.6572 26.8458 89.6924 26.9456 88.9605 26.9456C85.8999 26.9456 84.3363 25.4818 84.3363 22.3879V12.0416H81.8745V9.94578H84.3363V5.6875H87.0643V9.94578H91.4556V12.0416H87.031V22.2549C87.031 24.018 87.9292 24.6169 89.4596 24.6169C90.0917 24.6169 90.8235 24.5503 91.8881 24.2177Z" />
          <path d="M66.9148 9.94414V13.0048C67.7133 10.9422 69.8091 9.54492 72.3708 9.54492C76.13 9.54492 78.359 11.9069 78.359 15.8991V26.6778H75.5977V16.4979C75.5977 13.404 74.2337 11.8071 71.6056 11.8071C69.044 11.8071 67.0146 13.4373 67.0146 17.4627V26.6778H64.2534V9.94414H66.9148Z" />
          <path d="M55.2898 26.679V2.92578H58.1508V26.679H55.2898Z" />
        </svg>
        
        <form id="login-content" onSubmit={handleSubmit}>
          {errorMsg && <p style={{ color: 'red' }}>{errorMsg}</p>}
          
          <input
            className="form-input"
            type="text"
            id="login-email"
            name="email"
            onChange={handleChange}
            placeholder="Email"
            disabled={isLoading}
          />
          
          <div id="login-password-container">
            <input
              className="form-input"
              id="login-password"
              name="password"
              type="password"
              onChange={handleChange}
              placeholder="Password"
              disabled={isLoading}
            />
            <span
              id="password-visibility-state"
              className="material-symbols-outlined"
              onClick={togglePasswordVisibility}
            >
              visibility_off
            </span>
          </div>
          
          <input
            className="button button-center"
            type="submit"
            value={isLoading ? "Signing In..." : "Sign In"}
            disabled={isLoading}
          />
        </form>
      </div>
    </div>
  );
}

export default Login;